<template>
  <!-- @App Content -->
  <!-- Ver https://github.com/puikinsh/Adminator-admin-dashboard -->
  <!-- =================================================== -->
  <div class="app" :class="sideBarClass">
    <!-- #Left Sidebar ==================== -->
    <div class="sidebar">
      <div class="sidebar-inner">
        <!-- ### $Sidebar Header ### -->
        <div class="sidebar-logo">
          <div class="peers ai-c fxw-nw">
            <div class="peer peer-greed">
              <a class="sidebar-link td-n">
                <div class="peers ai-c fxw-nw col-6">
                  <div class="peer">
                    <div class="logo">
                      <img
                      style="object-fit: contain;"
                        class="lazyload img-circle"
                        width="80px"
                        src="@/assets/img/logo-1.png"
                        alt
                      />
                    </div>
                  </div>
                  <!-- <div class="peer">
                    <div class="logo">
                      <img
                        class="lazyload img-text"
                        width="10%"
                        src="@/assets/img/logo-2.png"
                        alt
                      />
                    </div>
                  </div> -->
                </div>
              </a>
            </div>
            <div class="peer">
              <div class="mobile-toggle sidebar-toggle">
                <a class="td-n" @click="sideBarTogle = !sideBarTogle">
                  <font-awesome-icon :icon="['fa', 'chevron-circle-left']" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <b-nav vertical class="sidebar-menu scrollable pos-r" pills>
          <b-nav-item
            :to="'/principal/dashboard'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Resume')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'home']" />
            </span>
            <span class="title">Inicio</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/providers'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
          >
          <!-- v-if="$can('view', 'Proveedores')" -->
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'boxes']" />
            </span>
            <span class="title">Proveedores</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/warehouse'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'warehouse']" />
            </span>
            <span class="title">Almacénes</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/client'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'id-card']" />
            </span>
            <span class="title">Clientes</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/orders'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'shopping-cart']" />
            </span>
            <span class="title">Pedidos</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/buy'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'cash-register']" />
            </span>
            <span class="title">Compras</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/sales'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'dollar-sign']" />
            </span>
            <span class="title">Ventas</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/stocktaking'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="myRoleId === 1"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'sort-amount-down']" />
            </span>
            <span class="title">Inventarios</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/reports'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'history']" />
            </span>
            <span class="title">Reportes</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/enterprises'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Tiendas')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'building']" />
            </span>
            <span class="title">Tiendas</span>
          </b-nav-item>

          <!-- <b-nav-item
            :to="'/principal/receipts'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Receipts')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'file-invoice-dollar']" />
            </span>
            <span class="title">Recibos</span>
          </b-nav-item> -->

          <!-- <b-nav-item
            :to="'/principal/metrics'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Metric')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'users-class']" />
            </span>
            <span class="title">Métricas</span>
          </b-nav-item> -->

          <b-nav-item
            :to="'/principal/users'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Usuarios')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'users']" />
            </span>
            <span class="title">Usuarios</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/roles'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Roles')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'user-astronaut']" />
            </span>
            <span class="title">Roles</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/modules'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Permisos')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'puzzle-piece']" />
            </span>
            <span class="title">Modulos y Permisos</span>
          </b-nav-item>

          <b-nav-item
            :to="'/principal/settings/general'"
            class="nav-item"
            exact
            exact-active-class="sidebar-active-link"
            v-if="$can('view', 'Settings')"
          >
            <span class="icon-holder">
              <font-awesome-icon :icon="['fa', 'users-cog']" />
            </span>
            <span class="title">Configuración</span>
          </b-nav-item>
        </b-nav>
      </div>
    </div>

    <!-- #Main ============================ -->
    <div class="page-container">
      <!-- ### $Topbar ### -->
      <div class="header navbar">
        <div class="header-container">
          <ul class="nav-left">
            <li>
              <a id="sidebar-toggle" class="sidebar-toggle" @click="sideBarTogle = !sideBarTogle">
                <font-awesome-icon :icon="['fa', 'bars']" />
              </a>
            </li>
          </ul>
          <ul class="nav-right">
            <li :class="'nav-item dropdown ' + class_show_menu">
              <a
                class="nav-link dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="fase"
                @click.prevent="showMenu"
              >
                <font-awesome-icon :icon="['fa', 'user-circle']" />
                {{ userName }}
              </a>
              <div :class="'dropdown-menu ' + class_show_menu" aria-labelledby="navbarDropdown">
                <b-nav-item
                  :to="'/principal/account'"
                  class="dropdown-item"
                  @click.prevent="showMenu"
                >Cuenta</b-nav-item>
                <!-- <a class="dropdown-item" href="#">Action</a> -->
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" @click.prevent="logout">
                  Salir
                  <font-awesome-icon :icon="['fa', 'sign-out-alt']" />
                </a>
              </div>
            </li>
            <li></li>
          </ul>
        </div>
      </div>

      <!-- ### $App Screen Content ### -->
      <main class="main-content bgc-grey-7070">
        <div id="mainContent">
          <router-view></router-view>
        </div>
      </main>

      <!-- ### $App Screen Footer ### -->
      <footer class="bdT ta-c p-30 lh-0 fsz-sm c-grey-600">
        <span>
          <Version />
        </span>
      </footer>
    </div>
  </div>
</template>

<script>
import { BNav, BNavItem } from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
const Version = () => import('@/components/general/Version.vue')

export default {
  components: {
    BNav,
    BNavItem,
    Version
  },
  data () {
    return {
      sideBarTogle: false,
      class_show_menu: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      rules: 'getRules'
    }),
    userName () {
      return `${this.user.name} ${this.user.last_name_1}`
    },
    sideBarClass () {
      return {
        'is-collapsed': this.sideBarTogle
      }
    },
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    ...mapActions({
      signOut: 'signOut',
      updateAbility: 'updateAbility'
    }),
    logout () {
      this.signOut()
      this.$router.push({ name: 'start' })
    },
    showMenu () {
      if (this.class_show_menu === '') {
        this.class_show_menu = 'show'
      } else {
        this.class_show_menu = ''
      }
    }
  },
  created () {
    if (this.$ability.rules.length === 0) {
      this.updateAbility(this.rules)
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 768px) {
  .logo{
    width: 7rem;
  }
  .logo img {
    align-items: center;
    margin-left: 20px;
    width: 60px;
  }
  .mobile-toggle {
    position: relative;
    z-index: 1000;
  }
  // .peer{
  //   width: 7rem;
  // }
}
</style>
